module.exports = __webpack_public_path__ + "img/cabeza_warning.c3b44c1e.svg";